import { defineMessages } from 'react-intl';

export default defineMessages({
  degradedTitle: {
    id: 'networkStatus.degraded.title',
    defaultMessage: 'Your connection seems slow',
  },
  degradedBody: {
    id: 'networkStatus.degraded.body',
    defaultMessage:
      'The app may be slower than usual and some actions could fail. This is caused by your network connection. Try moving closer to your router or checking your Wi-Fi.',
  },
  offlineTitle: {
    id: 'networkStatus.offline.title',
    defaultMessage: 'You are offline',
  },
  offlineBody: {
    id: 'networkStatus.offline.body',
    defaultMessage:
      'You have lost your network connection. The app will keep trying to reconnect. Check your Wi-Fi or mobile network.',
  },
});
